import type {
  CookieCategory,
  CookieRecord,
} from '../../../services/cookieTranslationService/types'

import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { CookieConsentActions } from '#src/assets/ui/banner/components/Actions.tsx'
import { CookieConsentDescription } from '#src/assets/ui/banner/components/Description.tsx'
import { CookieConsentFooter } from '#src/assets/ui/banner/components/Footer.tsx'
import { CookieConsentHeader } from '#src/assets/ui/banner/components/Header.tsx'
import { CookieOverview } from '#src/assets/ui/overview/components/CookieOverview.tsx'
import { FloatingPanel } from '#src/assets/ui/shared/components/FloatingPanel.tsx'
import type { SiteConfig } from '#src/models/site-configs/siteConfigs.ts'

export function CookieConsentBanner({
  t,
  locale,
  siteConfig,
  cookiesByCategory,
  visible,
  onAcceptAll,
  onRejectAll,
  onManagePreferences,
}: {
  t: CookieConsentTranslator
  locale: string
  siteConfig: SiteConfig
  cookiesByCategory: Record<CookieCategory, Array<CookieRecord>>
  visible: boolean
  onAcceptAll: () => void
  onRejectAll: () => void
  onManagePreferences: () => void
}) {
  return (
    <FloatingPanel
      className="lcc-mini-banner"
      visible={visible}
      maxWidth="36rem"
    >
      <CookieConsentHeader t={t}>
        <CookieConsentDescription t={t} siteConfig={siteConfig} />
      </CookieConsentHeader>

      <CookieOverview
        t={t}
        locale={locale}
        siteConfig={siteConfig}
        cookiesByCategory={cookiesByCategory}
      />
      <CookieConsentActions
        t={t}
        onAcceptAll={onAcceptAll}
        onRejectAll={onRejectAll}
        onManagePreferences={onManagePreferences}
      />
      <CookieConsentFooter t={t} siteConfig={siteConfig} />
    </FloatingPanel>
  )
}
